module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/title_banner-5f0f3ee7ed08daa0b6e154172eeafbd0.png";